import { HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { ConfigServerService, CustomHttp } from '../../../../core';
import { ArquivoFilter } from '../filter';
import { ArquivoSearch, ArquivoSearchTotal } from '../arquivo-search';

@Injectable({
    providedIn: 'root'
})
export class ArquivoSearchHttpService {
    private pathApi: string;

    constructor(configServerService: ConfigServerService,
                private customHttp: CustomHttp) {
        this.pathApi = `${configServerService.getPathApi()}/arquivos`;
    }


    /** Realizada a pesquisa dos arquivos */
    search(filter: ArquivoFilter, orderBy: number, orderByDir: string, limit: number, offset: number): Observable<ArquivoSearch[]> {
        // Params
        let params = new HttpParams();

        // Filter
        if (filter) {
            params = filter.createParams(params);
        }
        // Order By
        params = params.append('orderBy', orderBy ? orderBy.toString() : null)
                    .append('orderByDir', orderByDir ? orderByDir : null);
        // Limit
        params = params.append('limit', limit ? limit.toString() : null);
        // Offset
        params = params.append('offset', offset ? offset.toString() : null);

        return this.customHttp.get<ArquivoSearch[]>(this.pathApi, {params});
    }

    /** Obtem os totais da pesquisa dos arquivos */
    getTotais(filter: ArquivoFilter): Observable<ArquivoSearchTotal> {
        // Params
        let params = new HttpParams();

        // Filter
        if (filter) {
            params = filter.createParams(params);
        }

        return this.customHttp.get<ArquivoSearchTotal>(`${this.pathApi}/0/total`, {params});
    }
}
